import "core-js/modules/es.error.to-string.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
export var removeQueryParam = function removeQueryParam(history, location, param) {
  var queryParams = new URLSearchParams(location.search);
  if (queryParams.has(param)) {
    queryParams["delete"](param);
    history.replace({
      search: queryParams.toString()
    });
  }
};